import type { PaginatedResponse } from '@/types/api';
import type {
    EmployeeNote,
    EmployeeNoteCategory,
    EmployeeNoteCreateRequest,
    EmployeeNoteOriginFilter,
    EmployeeNoteUpdateRequest,
} from '@/types/employee-note';

import { api } from '@/api/api';

const notesUrl = (employeeId: string) => `/performance-profile/${employeeId}/notes`;

/**
 * The employee's notes: one route family shared by the "Notes et rétroaction" tab (every folder)
 * and the "Croissance" tab (the `Career` folder only), newest first, paged by the server.
 */
export default {
    async getEmployeeNotes(
        employeeId: string,
        category: EmployeeNoteCategory | null,
        pageNumber: number,
        pageSize: number,
        origin: EmployeeNoteOriginFilter = {},
    ): Promise<PaginatedResponse<EmployeeNote>> {
        const response = await api.get(notesUrl(employeeId), {
            params: { category: category ?? undefined, pageNumber, pageSize, ...origin },
        });
        return response.data;
    },

    async createEmployeeNote(
        employeeId: string,
        request: EmployeeNoteCreateRequest,
    ): Promise<EmployeeNote> {
        const response = await api.post(notesUrl(employeeId), request);
        return response.data;
    },

    async updateEmployeeNote(
        employeeId: string,
        noteId: string,
        request: EmployeeNoteUpdateRequest,
    ): Promise<EmployeeNote> {
        const response = await api.put(`${notesUrl(employeeId)}/${noteId}`, request);
        return response.data;
    },

    async deleteEmployeeNote(employeeId: string, noteId: string): Promise<void> {
        await api.delete(`${notesUrl(employeeId)}/${noteId}`);
    },
};
